import React from 'react';
import { FC } from 'react';
import './DeleteModal.css';
import i18n from 'i18next';

interface Props {
  handleClose: () => void;
  handleDelete: () => void;
  children: React.ReactNode;
  width?: string;
  height?: string;
}

const DeleteModal: FC<Props> = (props: Props) => {
  const { handleDelete, handleClose, children, width } = props;

  return (
    <div className="delte-modal" role="dialog" aria-modal="true" onClick={handleClose}>
      <div
        className="deletemodalContainer"
        role="document"
        style={width ? ({ ['--dm-w' as any]: width } as React.CSSProperties) : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ModalHeader">
          <h5 className="modal-title">
            <span>{i18n.t('actions.delete')}</span>
          </h5>
          <button type="button" className="platformDeleteClose" onClick={handleClose} aria-label={i18n.t('generic.close', { defaultValue: 'Close' })}>
            &times;
          </button>
        </div>

        <div className="modal-body">{children}</div>

        <div className="modal-footer">
          <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
            {i18n.t('actions.cancel')}
          </button>
          <button type="button" className="btn btn-danger" onClick={handleDelete}>
            {i18n.t('actions.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};
export default DeleteModal;
